import { Navigate } from "react-router-dom";

export function AdminCustomerCreatePage() {
	return <Navigate to="/clients?nouveau=true" replace />;
}
